/* unplugin-vue-components disabled */import script from "./Application.vue?vue&type=script&setup=true&name=Application&lang=js"
export * from "./Application.vue?vue&type=script&setup=true&name=Application&lang=js"

import "./Application.vue?vue&type=style&index=0&id=8d752a68&lang=scss&scoped=true"

import exportComponent from "E:\\new-admin\\3.0\\ruoyi-vue3-cli\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d752a68"]])

export default __exports__